import SliderBase, { Settings } from 'react-slick'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/pro-solid-svg-icons'

import './slick/slick.scss'
import './slick/slick-theme.scss'
import { FC } from 'react'

const Arrow: React.FC<React.ComponentProps<'div'>> = ({
  children,
  style,
  ...rest
}) => (
  <div
    {...rest}
    style={{
      ...style,
      color: '#757575',
      fontSize: '22px',
    }}
  >
    {children}
  </div>
)

export const Slider: FC<Settings> = (props) => (
  <SliderBase
    arrows
    speed={500}
    swipeToSlide
    useTransform
    adaptiveHeight
    prevArrow={
      <Arrow className="slick-prev">
        <FontAwesomeIcon icon={faChevronLeft} />
      </Arrow>
    }
    nextArrow={
      <Arrow className="slick-next">
        <FontAwesomeIcon icon={faChevronRight} />
      </Arrow>
    }
    {...props}
  />
)
